import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AlertFacadeService, AppAlert } from '@rogers/self-serve-common/alert';
import { AppSettingFacadeService } from '@rogers/self-serve-common/app-setting';
import { PageAlertFacadeService } from './page-alert-facade.service';
import { Observable } from 'rxjs';
import { RoutingService } from '@rogers/self-serve-utils/routing';
import { WindowService } from '@rogers/cdk/common/services';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, switchMap, tap } from 'rxjs/operators';
import { AppAlertComponent } from '../app-alert/app-alert.component';
import { AsyncPipe } from '@angular/common';

@UntilDestroy()
@Component({
  selector: 'fss-page-alert',
  templateUrl: './page-alert.component.html',
  imports: [AppAlertComponent, AsyncPipe],
})
export class PageAlertComponent implements OnInit {
  private readonly alertFacadeService = inject(AlertFacadeService);
  private readonly appSettingFacadeService = inject(AppSettingFacadeService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly pageAlertFacadeService = inject(PageAlertFacadeService);
  private readonly router = inject(Router);
  private readonly routingService = inject(RoutingService);
  private readonly windowService = inject(WindowService);

  pageAlert$: Observable<AppAlert>;
  showBanner = false;

  ngOnInit(): void {
    this.listenForRouteChanges();
  }

  onCtaClick(event) {
    if (!!event && (event.target === '_self' || event.target === '_blank')) {
      /*
         this.routingService.navigate() opens deeplinked url in the same tab even when
         target is '_blank', to open it in tab in new tab I am using .open()
       */
      this.windowService.windowRef().open(event.url, event.target);
    } else {
      this.routingService.navigate(event.url);
    }
  }

  onDismissAlert(key) {
    setTimeout(() => {
      this.alertFacadeService.hideAlert(key);
      this.resetState();
    }, 1200);
  }

  private stripQueryString(url: string): string {
    return url.split('?')[0];
  }

  private listenForRouteChanges() {
    this.router.events
      .pipe(untilDestroyed(this))
      .pipe(
        filter(event => event instanceof NavigationEnd),
        switchMap(event => {
          const url = (event as NavigationEnd).url;
          const urlWithoutQs = this.stripQueryString(url);
          return this.appSettingFacadeService.getSettingForContext$('top-banner-alerts').pipe(
            tap(settings => {
              const pageKey = settings.find(setting => setting.key === urlWithoutQs)?.value;
              if (pageKey) {
                this.showBanner = true;
                this.pageAlert$ = this.pageAlertFacadeService.getPageAlerts$(pageKey);
                this.pageAlertFacadeService.loadPageAlerts(pageKey);
              } else {
                this.resetState();
              }
              this.changeDetectorRef.markForCheck();
            }),
          );
        }),
      )
      .subscribe();
  }

  private resetState() {
    this.showBanner = false;
    this.pageAlert$ = null;
  }
}
